export default __webpack_public_path__ + "a311929d6150c6e9a453ed093c0e67cd.png";